import React, { Fragment, useEffect, useState } from "react";
import { Table, Modal } from "react-bootstrap";
import "./myAssessment.scss";
import { useNavigate } from "react-router-dom";
import TestDetailModal from "../../utils/testDetailModal";
import { useDispatch, useSelector } from "react-redux";
import {
  checkValidTest,
  createCustomTest,
  getSelectedTests,
} from "../../Redux/ActionCreators/testLibraryAction";
import {
  getMyTests,
  resetTestLoader,
} from "../../Redux/ActionCreators/myAssessmentAction";
import AddTestModal from "../../utils/addTestModal";
import "../Test-library/Test-results/testResult.scss";

export default function MyAssessment() {
  const [isOpen, setIsOpen] = useState(false);
  const [testName, setTestName] = useState("");
  const [testNameErr, setTestNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [isDetail, setIsDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { isTestLoading, myAssessments, total } = useSelector(
    (state) => state.myAssessment,
  );
  const { testDetails } = useSelector((state) => state.testLibrary);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const assessmentsPerPage = 10;

  const timerRef1 = React.useRef(null);

  useEffect(() => {
    dispatch(getMyTests(query, currentPage, assessmentsPerPage));
  }, [query, currentPage, assessmentsPerPage]);

  const searchTest = (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);
    setCurrentPage(1);
    timerRef1.current = setTimeout(() => {
      dispatch(resetTestLoader());
      dispatch(getMyTests(val, 1, assessmentsPerPage));
    }, 800);
  };

  const openReport = async (el) => {
    navigate("/assessments-report", {
      state: { id: el.testID, ruleSetJson: el.ruleSetJson },
    });
  };

  const openDetail = async (id) => {
    setIsLoading(true);
    setIsDetail(true);
    await dispatch(getSelectedTests(id));
    setIsLoading(false);
  };

  const editTest = (testId, type) => {
    if (type === "invite") {
      navigate("/home/invite-preview", {
        state: { testId: testId, myTest: true },
      });
    } else {
      navigate("/home/select-test", {
        state: { testId: testId, next: false },
      });
    }
  };

  const openAlert = () => {
    setIsAlert(true);
  };

  const goToReport = (el) => {
    navigate("/reports?tab=old", { state: { ruleSetJson: el.ruleSetJson } });
  };

  const validateNameViaApi = async (input) => {
    if (input !== "") {
      const res = await dispatch(checkValidTest(input));
      if (res?.payload?.isValid) {
        setTestNameErr("");
      } else {
        setTestNameErr("Test Name already exist");
      }
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      validateNameViaApi(testName);
    }, 200);

    return () => clearTimeout(delay);
  }, [testName]);

  const goToQuestion = async () => {
    setLoading(true);
    if (testName.trim("") === "") {
      setTestNameErr("Please Enter Test Name");
      setLoading(false);
    } else {
      let obj = {
        testName: testName,
        testLevel: 2,
        tests: [],
        testDescription: description,
        questions: [],
      };
      const res = await dispatch(createCustomTest(obj));
      if (res?.type === "CREATE_CUSTOM_TEST") {
        await setIsOpen(false);
        setTestName("");
        setTestNameErr("");
        navigate(`/home/select-test`, {
          state: { testId: res.payload, next: false },
        });
      }
    }
    setLoading(false);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(myAssessments.map((job) => job.testID));
    } else {
      setSelectedJobs([]);
    }
  };

  const handleSelectJob = (testID) => {
    setSelectedJobs((prev) =>
      prev.includes(testID)
        ? prev.filter((jobTestID) => jobTestID !== testID)
        : [...prev, testID],
    );
  };

  // Pagination logic
  const indexOfLastAssessment = currentPage * assessmentsPerPage;
  const indexOfFirstAssessment = indexOfLastAssessment - assessmentsPerPage;
  const totalPages = Math.ceil(total / assessmentsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    dispatch(resetTestLoader());
    setCurrentPage(pageNumber);
  };

  const Pagination = ({ currentPage, totalPages, paginate }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, "...", totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    };

    return (
      <div className="pagination">
        <div className="pagination-info">
          {myAssessments.length > 0 ? (
            <span>
              Showing <strong>{indexOfFirstAssessment + 1}</strong>-
              <strong>
                {Math.min(indexOfLastAssessment, indexOfLastAssessment + 10)}
              </strong>{" "}
              of <strong>{total}</strong>
            </span>
          ) : (
            <span>Showing 0-0 of 0</span>
          )}
        </div>
        <div className="pagination-buttons">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/images/leftarrow-icon.svg" alt="" />
          </button>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => (page === "..." ? null : paginate(page))}
              className={currentPage === page ? "active" : ""}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt=""
              style={{ rotate: "180deg" }}
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="gappeo-my-tests">
      <Fragment>
        <div className="gappeo-my-tests-head" style={{padding :'16px 0'}}>
          <div className="search-test d-flex justify-content-between align-items-center flex-wrap">
            <h1 className="text-center">Assessments</h1>
            <button className="float-right" onClick={() => setIsOpen(true)}>
              + Create Assessment
            </button>
          </div>
        </div>
        {/* assessments Table */}
        <div className="table-admin">
          <div
            className={
              window.innerWidth > 767
                ? "search-test d-flex"
                : "search-test mt-1"
            }
          >
            <div className="has-search">
              <span className="form-control-feedback">
                <img src="/images/search.svg" alt="" width={12} />
              </span>
              <input
                type="search"
                className="form-control"
                value={query}
                placeholder="Search for a test / job role / test category"
                onChange={(e) => searchTest(e.target.value)}
              />
            </div>
          </div>
          <Table responsive className="assessment-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" onChange={handleSelectAll} />
                </th>
                <th>ASSESSMENT NAME</th>
                <th>CANDIDATES INVITED</th>
                <th>COMPLETED BY</th>
                <th>REPORTS</th>
                <th>DETAILS</th>
                <th>NEW INVITE</th>
                <th>EDIT</th>
              </tr>
            </thead>
            {isTestLoading ? (
              <tr>
                <td colSpan="10">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#F75891",}}>
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : myAssessments?.length > 0 ? (
              <tbody className="table-body">
                {myAssessments?.map((el) => {
                  return (
                    <tr key={el.testID}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedJobs.includes(el.testID)}
                          onChange={() => handleSelectJob(el.testID)}
                        />
                      </td>
                      <td>
                        <h4 style={{ marginBottom: "5px" }}>
                          <strong>{el.testName}</strong>
                        </h4>
                        <p>
                          {el.questionCount} Qs | {el.duration} Mins
                        </p>
                      </td>
                      <td style={{ width: "190px" }}>
                        <div
                          className={
                            el.testsInvited > 0
                              ? "invite d-flex justify-content-center"
                              : "d-flex justify-content-center"
                          }
                          onClick={() =>
                            el.testsInvited > 0
                              ? navigate("/assessments/invitedCandidates", {
                                  state: {
                                    testId: el.testID,
                                    testName: el.testName,
                                    ruleSetJson: el.ruleSetJson,
                                  },
                                })
                              : null
                          }
                        >
                          &nbsp;&nbsp;
                          <div>
                            <h3>
                              {el.isNewTest === 1
                                ? el.testsInvited
                                : el.isNewTest === 0
                                  ? "NA"
                                  : el.testsInvited}
                            </h3>
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "180px" }}>
                        <div className="d-flex justify-content-center">
                          {/* <img src="/images/test-taken.svg" alt="" /> */}
                          &nbsp;&nbsp;
                          <div>
                            <h3>
                              {el.isNewTest === 1
                                ? el.testsTaken
                                : el.isNewTest === 0
                                  ? "NA"
                                  : el.testsTaken}
                            </h3>
                            {/* <p>Completed</p> */}
                          </div>
                        </div>
                      </td>
                      <td className="cursor-pointer">
                        {el.isNewTest === 1 ? (
                          <button
                            style={{
                              color:
                                el.testsInvited === 0 || el.testsTaken === 0
                                  ? "gray"
                                  : "#1F2A37",
                            }}
                            onClick={() =>
                              el.testsInvited === 0 || el?.testsTaken === 0
                                ? ""
                                : openReport(el)
                            }
                          >
                            REPORTS
                          </button>
                        ) : (
                          <button
                            style={{
                              color:
                                el.testsInvited === 0 || el.testsTaken === 0
                                  ? "gray"
                                  : "#1F2A37",
                            }}
                            onClick={() =>
                              el.testsInvited === 0 || el?.testsTaken === 0
                                ? ""
                                : goToReport(el)
                            }
                          >
                            REPORTS
                          </button>
                        )}
                      </td>
                      <td className="cursor-pointer text-center">
                        {el.isNewTest === 1 ? (
                          <button
                            style={{ color: "#1F2A37" }}
                            onClick={() => openDetail(el.testID)}
                          >
                            DETAILS
                          </button>
                        ) : (
                          "NA"
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        style={{ color: "#1F2A37" }}
                      >
                        {el.jobId ? (
                          <button
                            onClick={() =>
                              navigate(`/jobs/${el.jobId}/details`, {
                                state: { jobId: el.jobId },
                              })
                            }
                          >
                            View Job
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              el.isNewTest === 1
                                ? editTest(el.testID, "invite")
                                : openAlert()
                            }
                          >
                            Send invite
                          </button>
                        )}
                      </td>
                      <td className="cursor-pointer">
                        {el.isNewTest === 1 || el.isNewTest === 0 ? (
                          el.isDraft === 1 ? (
                            <img
                              src="/images/edit-icon.svg"
                              alt=""
                              onClick={() => editTest(el.testID, "select-test")}
                              title="Edit"
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <div className="empty-list">
                <img src="/images/magnifier.svg" alt="" />
                <div className="mt-2">
                  <h3>There is no tests</h3>
                </div>
              </div>
            )}
          </Table>
          {!isTestLoading &&
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              paginate={paginate}
            />
          }
        </div>
      </Fragment>

      {/* ########################## Test Details modal #######################3 */}
      <AddTestModal
        edit={false}
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
        testName={testName}
        testNameErr={testNameErr}
        setTestName={(e) => setTestName(e)}
        setTestNameErr={(e) => setTestNameErr(e)}
        goToQuestion={goToQuestion}
        loading={loading}
        description={description}
        setDescription={(val) => setDescription(val)}
        type="my-assessment"
      />

      {/* ########################## Test Details modal #######################3 */}
      <TestDetailModal
        isLoading={isLoading}
        isDetail={isDetail}
        setIsDetail={() => setIsDetail(false)}
        testDetails={testDetails}
      />

      {/* ########################## Alert modal #######################3 */}

      <Modal
        show={isAlert}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={this.handleCloseModal}
        dialogClassName={"confirm-modal "}
      >
        <div className="p-4">
          <h1>
            We have upgraded systems, pls create a new test and invite
            candidates
          </h1>
          <div className="save-btn text-center">
            <button onClick={() => setIsAlert(false)}>Ok</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
